import { Assignment, ExitToApp, Login, QrCode2 } from '@mui/icons-material';
import { lazy } from 'react';
import { DEFAULT_ROUTE, IRouteProps } from '../types';

const Logout = lazy(() => import('pages/AuthenticationPages/_components/Logout'));
const NewPassword = lazy(() => import('pages/AuthenticationPages/NewPasswordPage'));
const QRCodeLoginPage = lazy(() =>
	import('pages/AuthenticationPages/QRCodeLoginPage').then((m) => ({ default: m.QRCodeLoginPage })),
);
const RecoverPassword = lazy(() => import('pages/AuthenticationPages/RecoverPasswordPage'));
const SignInPage = lazy(() => import('pages/AuthenticationPages/SignInPage'));
const SignUpPage = lazy(() => import('pages/AuthenticationPages/SignUpPage'));
const SignUpProductPage = lazy(() => import('pages/AuthenticationPages/SignUpProductPage'));
const TokenPasswordPage = lazy(() => import('pages/AuthenticationPages/TokenPasswordPage'));
const WelcomePage = lazy(() => import('pages/AuthenticationPages/WelcomePage'));

export const authRoutes: IRouteProps[] = [
	{
		type: 'hide',
		name: 'Sign In',
		key: 'sign-in',
		icon: <Login />,
		route: `${DEFAULT_ROUTE}/authentication/signIn`,
		component: <SignInPage />,
	},
	{
		type: 'hide',
		name: 'Token Password',
		key: 'token-password',
		icon: <Login />,
		route: `${DEFAULT_ROUTE}/authentication/tokenPassword`,
		component: <TokenPasswordPage />,
	},
	{
		type: 'hide',
		name: 'Sign Up',
		key: 'sign-up',
		icon: <Assignment />,
		route: `${DEFAULT_ROUTE}/authentication/signUp`,
		component: <SignUpPage />,
	},
	{
		type: 'hide',
		name: 'SignUp Product',
		key: 'signUp-product',
		icon: <Assignment />,
		route: `${DEFAULT_ROUTE}/authentication/signUpProduct`,
		component: <SignUpProductPage />,
	},
	{
		type: 'hide',
		name: 'SignUpWelcome',
		key: 'signUp-welcome',
		icon: <Assignment />,
		route: `${DEFAULT_ROUTE}/authentication/Welcome`,
		component: <WelcomePage />,
	},
	{
		type: 'hide',
		name: 'Recover Password',
		key: 'recover-password',
		icon: <Assignment />,
		route: `${DEFAULT_ROUTE}/authentication/recoverPassword`,
		component: <RecoverPassword />,
	},
	{
		type: 'hide',
		name: 'New Password',
		key: 'new-password',
		icon: <Assignment />,
		route: `${DEFAULT_ROUTE}/authentication/newPassword`,
		component: <NewPassword />,
	},
	{
		type: 'hide',
		name: 'QRCodeLogin',
		key: 'qrcode-login',
		icon: <QrCode2 />,
		route: `${DEFAULT_ROUTE}/auth/QRCode/login/:token?`,
		component: <QRCodeLoginPage />,
	},
	{
		type: 'hide',
		name: 'routersNames.logout',
		key: 'logout',
		icon: <ExitToApp />,
		route: `${DEFAULT_ROUTE}/logout`,
		component: <Logout />,
		protected: true,
		hideInMenu: true,
	},
];
